import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Skeleton, Table, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Drawer, Popconfirm, Input, Slider } from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, HolderOutlined, EditOutlined, EyeOutlined, InstagramFilled, PlusOutlined, CopyOutlined } from '@ant-design/icons';
import { AutoReply } from "../../comps/automate/main";
import callAPI from "../../comps/fetch/main";
import { v4 as uuidv4 } from 'uuid';
import { fireDB } from "../../funcs/firebase";
import { getDocs, collection } from "firebase/firestore";
import WhatsNew from "../../comps/whatsNew/main";

function RefferalList() {

    const [getAllRefCode, setAllRefCode] = useState()
    const [getRefferalList, setGetRefferalList] = useState(undefined)
    const [postReffealCode, setPostRefferalCode] = useState()

    const [loadingState, setLoadingState] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();

    const [showDrawer, setShowDrawer] = useState(false)

    const [selectedReferalCode, setSelectedRefferalCode] = useState({})

    const [clientComission, setClientComission] = useState(0)
    const [refcodeInput, setRefCodeInput] = useState()

    const [updateRefCode, setUpdateRefCode] = useState()
    const [updateRefCodeBE, setUpdateRefCodeBE] = useState()

    const [currentBalance, setCurrentBalance] = useState({})
    const [withdrawRequest, setWithDrawRequest] = useState([])

    const [openWithdraw, setOpenWithDraw] = useState(false)

    const [loadingPostData, setLoadingPostData] = useState(false)
    const [withdrawPostResponse, setWithDrawPostResponse] = useState()

    const [selectedWithdrawDetail, setSelectedWithdrawDetail] = useState({})


    let plan_ids = {
        "566420": "Growth",
        "566421": "Growth Yearly",
        "566422": "Legend",
        "566423": "Legend Yearly",
        "000003": "Legend Pro",
        "0000031": "Legend Pro Yearly",
        "428337": "Trendsetter",
        "428338": "Trendsetter Yearly",
        "201": "Multiplex Lite",
        "2011": "Multiplex Lite Yearly",
        "202": "Multiplex Pro",
        "2021": "Multiplex Pro Yearly",
        "203": "Multiplex Max",
        "2041": "Multiplex Max Yearly",
        "204": "Multiplex Ultra",
        "2041": "Multiplex Ultra Yearly",
    }



    useEffect(() => {

        if (!withdrawPostResponse) {
            return
        }


        let user_detail = JSON.parse(localStorage.getItem("userData"))
        let igid = localStorage.getItem("ig_id")

        const BOT_TOKEN = "7568542822:AAHp0XrDQw1Fg1iTbG4OvsWYHCjsEYPPFYw";
        const CHAT_ID = '776956029';
        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `[Request withdraw] - user ${user_detail.emailid}  - ${selectedWithdrawDetail.currency} ${selectedWithdrawDetail.amount}  , IG ID = ${igid} , user id = ${user_detail.user_id}`
        let data = {
            chat_id: CHAT_ID,
            text: tele_message
        };



        if (withdrawPostResponse?.code != 200) {

            message.error(withdrawPostResponse?.message)
            setWithDrawPostResponse()
            return

        }


        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Message sent successfully:', data);
            })
            .catch(error => {
                console.error('Error sending message:', error);
            });


        message.success("Request submitted! Our team will contact you.")

        setCurrentBalance[selectedWithdrawDetail.currency] = 0
        setOpenWithDraw(false)
        setSelectedWithdrawDetail({})
    }, [withdrawPostResponse])

    const submitWithdrawRequest = ({ amount, currency }) => {



        let data = { amount, currency }

        let apiURL = `/withdraw_commission`
        setSelectedWithdrawDetail(data)
        callAPI({ url: apiURL, method: "POST", body: data, loadingState: setLoadingPostData, dataState: setWithDrawPostResponse })



    }


    useEffect(() => {

        if (!updateRefCode) {
            return
        }
        if ((refcodeInput || "").length < 4) {

            message.error("Ref code should be minimum 4 digit.", 10)
            setUpdateRefCode(false)
            return

        }


        let apiURL = `/ref_code`
        callAPI({ url: apiURL, method: "POST", body: { ...selectedReferalCode, client_discount: clientComission, ref_code: refcodeInput }, loadingState: setLoadingState, dataState: setUpdateRefCodeBE })

    }, [updateRefCode])


    useEffect(() => {
        if (!updateRefCodeBE) {
            return
        }
        if (updateRefCodeBE?.code != undefined && updateRefCodeBE?.code == 400) {
            message.error("This Ref Code is not avialable, Please choose different code", 10)
        }

        if (updateRefCodeBE?.code != undefined && updateRefCodeBE?.code == 200) {

            message.success("Changes Saved", 10)
            setShowDrawer(false)
            setUpdateRefCode(false)
            window.location.reload();
            return
        }

    }, [updateRefCodeBE])

    useEffect(() => {


        if (!getAllRefCode) {
            return
        }
        if (getAllRefCode?.data) {
            // Set commision earned
            // set withdraw request
            setCurrentBalance(getAllRefCode.commision)
            setWithDrawRequest(getAllRefCode.withdraws)
            setAllRefCode(getAllRefCode.data)
        }
        if (getAllRefCode.length > 0) {
            let ref_code = getAllRefCode[0].ref_code
            setSelectedRefferalCode(getAllRefCode[0])
            getRefDetails(ref_code)


        }

    }, [getAllRefCode])


    useEffect(() => {

        if (getRefferalList == undefined) {
            return
        }
        if (getRefferalList?.data) {
            setGetRefferalList(getRefferalList.data)
        }

    }, [getRefferalList])

    const getRefDetails = (ref_code) => {
        let apiURL = `/ref_code?ref_code=${ref_code}`
        callAPI({ url: apiURL, method: "GET", loadingState: setLoadingState, dataState: setGetRefferalList })
    }



    useEffect(() => {

        if (getAllRefCode == undefined) {

            let apiURL = `/ref_code`
            callAPI({ url: apiURL, method: "GET", loadingState: setLoadingState, dataState: setAllRefCode })

        }
    }, [])

    let defaultColumns = [
        {
            title: 'User Name',
            render: (_, record, index) => (

                <a href={record?.username ? `https://instagram.com/${record?.username}` : '#'} target={record?.username && `_blank`}>{record?.username || "IG Not connected"}</a>
            )


        },
        {
            title: 'Current Plan',
            render: (_, record, index) => (
                <p>  {plan_ids[record?.crrent_plan] || record?.crrent_plan} </p>),
        },
        {
            title: 'Joined on',
            render: (_, record, index) => (
                <p>  {record?.created_at} </p>),
        },
    ]

    const [earnings, setEarnings] = useState({})
    const [processing, setProcessing] = useState({})
    const [settled, setSettled] = useState({})

    useEffect(() => {
        let totalEarnings = {};

        // Start with the current balance
        Object.entries(currentBalance).forEach(([currency, amount]) => {
            totalEarnings[currency] = parseFloat(amount) || 0;
        });

        // Add withdrawals (both requested and settled)
        withdrawRequest.forEach(({ amount, currency }) => {
            totalEarnings[currency] = (totalEarnings[currency] || 0) + parseFloat(amount);
        });

        setEarnings(totalEarnings);
    }, [currentBalance, withdrawRequest]);

    useEffect(() => {
        let totalProcessing = {};

        withdrawRequest.forEach(({ amount, currency, status }) => {
            if (status === "requested") {
                totalProcessing[currency] = (totalProcessing[currency] || 0) + parseFloat(amount);
            }
        });

        setProcessing(totalProcessing);
    }, [withdrawRequest]);

    useEffect(() => {
        let totalSettled = {};

        withdrawRequest.forEach(({ amount, currency, status }) => {
            if (status === "settled") {
                totalSettled[currency] = (totalSettled[currency] || 0) + parseFloat(amount);
            }
        });

        setSettled(totalSettled);
    }, [withdrawRequest]);

    return (
        <div className="page-layout">
            {contextHolder}


            <Sider />

            <div className="page-content">
                <WhatsNew />




                <h2>Your Referral dashboard!</h2>
                <p style={{ color: "grey" }}>Earn 50% commision on your every referral when they purchase monthly plan for the first time.</p>
                <div style={{ display: "flex", flexDirection: "row", gap: "20px", marginBottom: "20px", flexWrap: "wrap" }}>

                    {Object.entries(currentBalance) == 0 && <Card><Statistic title={`Total Earnings`} value={`0`} /></Card>}
                    {Object.entries(currentBalance) == 0 && <Card><Statistic title={`Available Balance`} value={`0`} /></Card>}

                    {Object.entries(earnings).map(([currency, amount]) => (
                        <Card key={currency}><Statistic title={`Total Earnings ${currency}`} value={`${currency} ${amount}`} /></Card>
                    ))}

                    {Object.entries(currentBalance).map(([currency, amount]) => (
                        <Card key={currency}><Statistic title={`Avai Balance ${currency}`} value={`${currency} ${amount}`} /></Card>
                    ))}

                    {Object.entries(processing).map(([currency, amount]) => (
                        <Card key={currency}><Statistic title={`Processing Withdraw ${currency}`} value={`${currency} ${amount}`} /></Card>
                    ))}

                    {Object.entries(settled).map(([currency, amount]) => (
                        <Card key={currency}><Statistic title={`Settled Payments ${currency}`} value={`${currency} ${amount}`} /></Card>
                    ))}


                    <Button onClick={() => setOpenWithDraw(true)} size="large" type="primary">Withdraw My Earnings</Button>


                </div>

                {getAllRefCode instanceof Array &&

                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px", marginBottom: "20px" }}>



                        <Button type="primary" onClick={() => { setSelectedRefferalCode(); setRefCodeInput(); setClientComission(0); setShowDrawer(true) }} color="primary" style={{ marginLeft: "0px" }} size="large" variant="filled" icon={<PlusOutlined />}> Create new coupon code </Button>

                        {
                            getAllRefCode.length < 1 && <p style={{ color: "grey" }}>Create your referral code and start making money.</p>
                        }
                        {

                            getAllRefCode.map(
                                (ref_code) => {
                                    return <Tag onClick={() => { getRefDetails(ref_code.ref_code); setSelectedRefferalCode(ref_code) }} id={ref_code.ref_code} color={ref_code.ref_code == selectedReferalCode?.ref_code ? "purple" : "default"} style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center", alignItems: "center", justifyItems: "center", textAlign: "center", width: "100px", padding: "10px", fontWeight: "600", cursor: "pointer" }}>
                                        {ref_code.ref_code}
                                    </Tag>
                                }
                            )
                        }
                    </div>

                }
                <Tooltip title="Click to Copy">
                    {selectedReferalCode?.ref_code && <Button

                        icon={<CopyOutlined />}

                        onClick={() => {
                            const link = `https://instantdm.com?ref=${selectedReferalCode?.ref_code}`;
                            navigator.clipboard.writeText(link);
                            message.success("Copied to clipboard!");
                        }}

                        color="primary" style={{ marginRight: "20px" }} variant="dahsed">https://instantdm.com?ref={selectedReferalCode?.ref_code}</Button>}
                </Tooltip>
                {selectedReferalCode?.client_discount && <Button onClick={() => { setRefCodeInput(selectedReferalCode.ref_code); setClientComission(selectedReferalCode.client_discount || 0); setShowDrawer(true); }} style={{ marginBottom: "10px" }}>Edit Commision details? Click here!</Button>}
                {getRefferalList instanceof Array &&

                    <Table
                        bordered
                        dataSource={getRefferalList || []}
                        rowKey="user_id"
                        columns={defaultColumns}
                    />

                }


                <Drawer open={showDrawer}
                    title="Referral code"
                    onClose={() => setShowDrawer(false)}
                >

                    <div>
                        <h3>Referral Code</h3>
                        <Input value={refcodeInput} onChange={(e) => setRefCodeInput(e.target.value)} placeholder="Your referral code" disabled={selectedReferalCode?.ref_code != undefined} />
                    </div>

                    <Alert style={{ marginTop: "20px" }} type="success" message={"Earn Upto 50% Affiliate commission, on the first payment of montly subscription"} />
                    <div>
                        <h3>Client discount - ({clientComission}%)</h3>
                        <p>Give discounts to your clients.</p>
                        <Slider marks={{ 0: "0%", 50: "50%" }} value={clientComission} onChange={(value) => setClientComission(value)} min={0} max={50} step={1} />
                    </div>
                    <div>
                        <h3>Your commission - ({50 - clientComission}%)</h3>
                        {/* <Slider marks={{0:"0%" , 50:"50%"}} value={50 - clientComission} min={0} max={50} step={5} disabled /> */}
                    </div>

                    <Card title="Commission Summary">
                        {/* <h4>Summary: </h4> */}
                        <p>1. If Your clients purchase a plan of <b>$25</b> </p>
                        <p>2. Your Client will get discount of <b>${(25 * (clientComission / 100)).toFixed(2)}</b> </p>
                        <p>3. You'll get Commision of <b>${(25 * (50 - clientComission) / 100).toFixed(2)}</b> </p>
                        <p>You can edit this later.</p>
                    </Card>

                    <Button onClick={() => { setUpdateRefCode(true) }} style={{ marginTop: "10px" }} type="primary" block>{selectedReferalCode?.ref_code != undefined ? "Update your ref code" : "Create Ref code"}</Button>

                </Drawer>


                <Modal open={openWithdraw} title="Widraw request" onCancel={() => setOpenWithDraw(false)} footer={null}>

                    <p>Amount will be creditd in 24 hours.</p>

                    {Object.entries(currentBalance) == 0 && <Empty description="No balance found." />}

                    {Object.entries(currentBalance).map(([currency, amount]) => (
                        <Card style={{ marginBottom: "10px" }} key={currency}><Statistic title={`Available Balance ${currency}`} value={`${currency} ${amount}`} />
                            {amount > 0 && <Button disabled={loadingPostData} onClick={() => submitWithdrawRequest({ amount, currency })} block>Withdraw</Button>} </Card>
                    ))}

                </Modal>

                <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "20px", flexWrap: "wrap" }}>

                    {
                        [
                            "https://public-assets.instantdm.com/product-refferal-videos/Same+Features%2C+Big+Price+Gap!+%F0%9F%A4%AFComment+-+Automation+kisliye+use+karna+chahte+hoAlso+-+Link+in+B.mp4",
                            "https://public-assets.instantdm.com/product-refferal-videos/AQO9BX61tJ0xmSV8LWLYwesAyAPCVz0inB42ecI56OKRKoDv6_Xywih6eEzzuGZSJpG94ovXitdfuhrL0VwpPyvAqnsjxcSq1SLdHOk.mp4",
                            "https://public-assets.instantdm.com/product-refferal-videos/AQOR2Sb0oDVjTtUbtxt_A5sUJDmfZkMfoHuCLx07V0H6SjrdMa_YkA0dmA1x5FlWd2Rd0-OgY0bxcXGpQtCsh_PsaP6KOVDxabChhag.mp4",
                            "https://public-assets.instantdm.com/product-refferal-videos/Grow+your+Insta%2C+not+your+workload+%F0%9F%93%88Let+%40instant.dm+handle+your+comment+replies.+Just+%E2%82%B9499-mont.mp4",
                            "https://public-assets.instantdm.com/product-refferal-videos/indonesia-1.mp4",
                            "https://public-assets.instantdm.com/product-refferal-videos/AQNL4Co1qJqQWLRSOHYTZ_F0uGeg1S3RYmWyG9nJImyzEGPmmUX1GbNZPY0uDWnRlg8WvicR8Tr-lz2sJo0vAYO6Q3BlduP5vxe-iYA.mp4"
                        ].map((vide, index) => (
                            <video key={index} style={{ maxWidth: "40%", height: "300px", margin: "10px" }} autoPlay muted controls>
                                <source src={vide} type="video/mp4" />
                            </video>
                        ))
                    }

                </div>

            </div>
        </div>
    )
}

export default RefferalList